module.exports = `${require.publicPath}104.e4e4c9ba.png`;